import router from 'next/router'
import { resolveHref } from 'next/dist/shared/lib/router/utils/resolve-href'
import { addBasePath } from 'next/dist/client/add-base-path'
import { getLocationOrigin } from 'next/dist/shared/lib/utils'

function stripOrigin(url) {
	const origin = getLocationOrigin()

	return url.startsWith(origin) ? url.substring(origin.length) : url
}

function prepareUrlAs(router, url, as) {
	// If url and as provided as an object representation,
	// we'll format them into the string version here.
	let [resolvedHref, resolvedAs] = resolveHref(router, url, true)
	const origin = getLocationOrigin()
	const hrefHadOrigin = resolvedHref.startsWith(origin)
	const asHadOrigin = resolvedAs && resolvedAs.startsWith(origin)

	resolvedHref = stripOrigin(resolvedHref)
	resolvedAs = resolvedAs ? stripOrigin(resolvedAs) : resolvedAs

	const preparedUrl = hrefHadOrigin ? resolvedHref : addBasePath(resolvedHref)
	const preparedAs = as ? stripOrigin(resolveHref(router, as)) : resolvedAs || resolvedHref

	return {
		url: preparedUrl,
		as: asHadOrigin ? preparedAs : addBasePath(preparedAs),
	}
}

export const useNextHistory = () => {
	const handle = (method, url, as, options) => {
		;({ url, as } = prepareUrlAs(router, url, as))

		window.history[method](
			{
				url,
				as,
				options,
				__N: true,
				idx: (router._idx = method !== 'pushState' ? router._idx : router._idx + 1),
			},
			// Most browsers currently ignores this parameter, although they may use it in the future.
			// Passing the empty string here should be safe against future changes to the method.
			// https://developer.mozilla.org/en-US/docs/Web/API/History/replaceState
			'',
			as
		)
	}

	return { push: (...args) => handle('pushState', ...args), replace: (...args) => handle('replaceState', ...args) }
}
